/* CPY Dark Streetwear Theme — cpy-theme.js */
'use strict';

const CPY = {
  cartDrawer: null,
  quickAddModal: null,

  init() {
    this.cartDrawer = document.getElementById('cart-drawer');
    this.quickAddModal = document.getElementById('quick-add-modal');
    this.bindEvents();
    this.initScrollReveal();
    this.updateCartCount();
    this.initHeroVideo();
  },

  initHeroVideo() {
    const video = document.querySelector('.cpy-hero__video');
    if (!video) return;
    const src = video.dataset.videoSrc;
    if (!src) return;
    const loadVideo = () => {
      const source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
      video.play().catch(() => {
        video.classList.add('cpy-hero__video--ready');
        const poster = document.querySelector('.cpy-hero__poster');
        if (poster) poster.classList.add('cpy-hero__poster--hidden');
      });
      video.addEventListener('canplay', () => {
        video.classList.add('cpy-hero__video--ready');
        const poster = document.querySelector('.cpy-hero__poster');
        if (poster) poster.classList.add('cpy-hero__poster--hidden');
      }, { once: true });
    };
    if (document.readyState === 'complete') {
      loadVideo();
    } else {
      window.addEventListener('load', loadVideo, { once: true });
    }
  },

  bindEvents() {
    // Cart drawer open
    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      btn.addEventListener('click', () => this.openCartDrawer());
    });
    // Cart drawer close
    document.querySelectorAll('[data-close-drawer]').forEach(el => {
      el.addEventListener('click', () => this.closeCartDrawer());
    });
    // Quick add modal close
    document.querySelectorAll('[data-close-modal]').forEach(el => {
      el.addEventListener('click', () => this.closeQuickAddModal());
    });
    // Desktop dropdown — click toggle
    document.querySelectorAll('.cpy-header__dropdown-toggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const wrap = btn.closest('.cpy-header__dropdown');
        const isOpen = wrap.classList.contains('is-open');
        document.querySelectorAll('.cpy-header__dropdown.is-open').forEach(d => d.classList.remove('is-open'));
        if (!isOpen) wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
    document.addEventListener('click', () => {
      document.querySelectorAll('.cpy-header__dropdown.is-open').forEach(d => {
        d.classList.remove('is-open');
        d.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
      });
    });

    // Mobile menu
    const hamburger = document.querySelector('.cpy-header__hamburger');
    const mobileNav = document.querySelector('.cpy-mobile-nav');
    const navClose  = document.querySelector('.cpy-mobile-nav__close');
    function closeMobileNav() {
      hamburger?.classList.remove('open');
      mobileNav?.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', () => {
        hamburger.classList.toggle('open');
        mobileNav.classList.toggle('open');
        document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
      });
    }
    navClose?.addEventListener('click', closeMobileNav);
    // Mobile subgroup toggle
    mobileNav?.querySelectorAll('.cpy-mobile-nav__group-toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.cpy-mobile-nav__group');
        const isOpen = group.classList.contains('is-open');
        group.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
    // Close on link tap (mobile)
    mobileNav?.querySelectorAll('.cpy-mobile-nav__sublink, a.cpy-mobile-nav__link').forEach(a => {
      a.addEventListener('click', closeMobileNav);
    });
    // Add to cart forms
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-add-btn]');
        const variantId = form.querySelector('[name="id"]')?.value;
        if (!variantId) return;
        if (btn) { btn.disabled = true; btn.textContent = 'AGREGANDO...'; }
        await this.addToCart(variantId, 1);
        if (btn) { btn.disabled = false; btn.textContent = 'AGREGAR AL CARRO'; }
      });
    });
    // Variant buttons (product page)
    document.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.classList.contains('sold-out')) return;
        const group = this.closest('[data-option-group]');
        if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        CPY.updateSelectedVariant();
        CPY.updateCrossOptionAvailability();
      });
    });
    // Description accordion
    document.querySelectorAll('.cpy-product__desc-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const isOpen = content.classList.contains('open');
        content.classList.toggle('open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
        this.querySelector('.acc-icon').textContent = isOpen ? '+' : '−';
      });
    });
    // Product thumbnails
    document.querySelectorAll('.cpy-product__thumb').forEach(thumb => {
      thumb.addEventListener('click', function() {
        document.querySelectorAll('.cpy-product__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const mainImg = document.querySelector('.cpy-product__main-img img');
        if (mainImg) mainImg.src = this.dataset.src;
      });
    });
    // Cart page qty buttons
    document.querySelectorAll('.cpy-cart-line__qty-btn').forEach(btn => {
      btn.addEventListener('click', async function() {
        const line = this.closest('.cpy-cart-line');
        const key = line?.dataset.key;
        const input = line?.querySelector('.cpy-cart-line__qty-val');
        if (!key || !input) return;
        const currentQty = parseInt(input.value) || 1;
        const delta = this.dataset.delta === 'up' ? 1 : -1;
        const newQty = Math.max(0, currentQty + delta);
        await CPY.updateLineQty(key, newQty);
        if (newQty === 0) { line.remove(); }
        else { input.value = newQty; }
        await CPY.refreshCartTotals();
      });
    });
    // Cart page remove
    document.querySelectorAll('.cpy-cart-line__remove').forEach(btn => {
      btn.addEventListener('click', async function() {
        const line = this.closest('.cpy-cart-line');
        const key = line?.dataset.key;
        if (!key) return;
        await CPY.updateLineQty(key, 0);
        line.remove();
        await CPY.refreshCartTotals();
      });
    });
    // Cart page wishlist buttons
    CPY.initCartPageWishlistBtns();
    // Checkout buttons are now intercepted by initPackagingSelector via event delegation
    // Discount input
    const discountBtn = document.querySelector('.cpy-discount-btn');
    const discountInput = document.querySelector('.cpy-discount-input');
    if (discountBtn && discountInput) {
      discountBtn.addEventListener('click', () => {
        const code = discountInput.value.trim().toUpperCase();
        if (code) { localStorage.setItem('cpy_discount', code); discountBtn.textContent = '✓ APLICADO'; }
      });
      const saved = localStorage.getItem('cpy_discount');
      if (saved) { discountInput.value = saved; discountBtn.textContent = '✓ APLICADO'; }
    }
    // Size guide drawer — carga las tablas desde /pages/guia-de-tallas via Section Rendering API
    const sgDrawer   = document.querySelector('[data-size-guide-drawer]');
    const sgBackdrop = document.querySelector('[data-size-guide-backdrop]');
    const sgContent  = document.querySelector('[data-size-guide-content]');
    let sgLoaded = false;

    const openSizeGuide = () => {
      sgDrawer?.classList.add('open');
      sgBackdrop?.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (!sgLoaded && sgContent) {
        fetch('/pages/guia-de-tallas')
          .then(r => r.text())
          .then(html => {
            const start = html.indexOf('<div data-size-tables>');
            const end   = start !== -1 ? html.indexOf('</div><!-- /size-tables -->', start) : -1;
            if (start !== -1 && end !== -1) {
              sgContent.innerHTML = html.slice(start, end + '</div><!-- /size-tables -->'.length);
            } else if (start !== -1) {
              // fallback: grab from marker to next major closing landmark
              sgContent.innerHTML = html.slice(start, start + 8000);
            } else {
              sgContent.innerHTML = '<p style="padding:1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.75rem">Error cargando la guía. <a href="/pages/guia-de-tallas" style="color:var(--red)">Ver página ↗</a></p>';
            }
            sgLoaded = true;
          })
          .catch(() => {
            sgContent.innerHTML = '<p style="padding:1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.75rem">Error cargando la guía. <a href="/pages/guia-de-tallas" style="color:var(--red)">Ver página ↗</a></p>';
          });
      }
    };
    const closeSizeGuide = () => {
      sgDrawer?.classList.remove('open');
      sgBackdrop?.classList.remove('open');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-open-size-guide]').forEach(btn => btn.addEventListener('click', openSizeGuide));
    document.querySelectorAll('[data-close-size-guide]').forEach(btn => btn.addEventListener('click', closeSizeGuide));
    sgBackdrop?.addEventListener('click', closeSizeGuide);
  },

  async addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await this.refreshCartDrawer();
      this.openCartDrawer();
    } catch (_err) {
      // cart error silenced in production
    }
  },

  async updateLineQty(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  },

  async refreshCartDrawer() {
    const cart = await this.getCart();
    this.updateCartCount(cart.item_count);
    const itemsEl = document.getElementById('cart-drawer-items');
    const totalEl = document.getElementById('cart-drawer-total');
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>TU CARRITO ESTÁ VACÍO</p><a href="/collections/all" class="btn-outline" style="font-size:0.62rem;padding:10px 24px;letter-spacing:0.14em">VER PRODUCTOS</a></div>';
    } else {
      const wlList = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
      itemsEl.innerHTML = cart.items.map(item => {
        const saved = wlList.includes(item.handle);
        return `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item__img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="cart-item__body">
            <div class="cart-item__top">
              <div class="cart-item__info">
                <div class="cart-item__title">${item.product_title}</div>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
                <div class="cart-item__price">${this.formatMoney(item.final_line_price)}</div>
              </div>
              <div class="cart-item__qty">
                <button class="cart-item__qty-btn" onclick="CPY.changeDrawerQty('${item.key}', ${item.quantity - 1})">−</button>
                <span class="cart-item__qty-num">${item.quantity}</span>
                <button class="cart-item__qty-btn" onclick="CPY.changeDrawerQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
            <div class="cart-item__actions">
              <button class="cart-item__wishlist-btn${saved ? ' saved' : ''}"
                data-key="${item.key}"
                onclick="CPY.saveCartItemToWishlist('${item.handle}', ${item.variant_id}, this)">
                ${saved ? '♥ GUARDADO' : '♡ GUARDAR'}
              </button>
              <button class="cart-item__remove" onclick="CPY.removeDrawerItem('${item.key}')">
                ELIMINAR
              </button>
            </div>
          </div>
        </div>`;
      }).join('');
    }
    if (totalEl) totalEl.textContent = this.formatMoney(cart.total_price);
  },

  async changeDrawerQty(key, qty) {
    if (qty < 0) return;
    await this.updateLineQty(key, qty);
    await this.refreshCartDrawer();
  },

  async removeDrawerItem(key) {
    await this.updateLineQty(key, 0);
    await this.refreshCartDrawer();
  },

  async refreshCartTotals() {
    const cart = await this.getCart();
    this.updateCartCount(cart.item_count);
    const totalEl = document.querySelector('.cpy-cart-summary__total-price');
    if (totalEl) totalEl.textContent = this.formatMoney(cart.total_price);
  },

  saveCartItemToWishlist(handle, variantId, btn) {
    const list = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    const variants = JSON.parse(localStorage.getItem('cpy_wishlist_variants') || '{}');
    const idx = list.indexOf(handle);
    const adding = idx === -1;
    if (adding) {
      list.push(handle);
      variants[handle] = variantId;
    } else {
      list.splice(idx, 1);
      delete variants[handle];
    }
    localStorage.setItem('cpy_wishlist', JSON.stringify(list));
    localStorage.setItem('cpy_wishlist_variants', JSON.stringify(variants));
    CPY.updateWishlistUI();

    if (adding) {
      // Remove from cart
      const cartKey = btn?.dataset.key || btn?.closest('[data-key]')?.dataset.key;
      if (cartKey) {
        btn.innerHTML = '♥ GUARDADO';
        btn.disabled = true;
        CPY.updateLineQty(cartKey, 0).then(() => {
          // In drawer: refresh; in page: remove line + update totals
          if (document.getElementById('cart-drawer-items')) {
            CPY.refreshCartDrawer();
          } else {
            btn.closest('.cpy-cart-line')?.remove();
            CPY.refreshCartTotals();
          }
        });
        return;
      }
    }

    if (btn) {
      const saved = list.includes(handle);
      btn.classList.toggle('saved', saved);
      btn.innerHTML = (saved ? '♥ GUARDADO' : '♡ GUARDAR');
      btn.disabled = false;
    }
  },

  initCartPageWishlistBtns() {
    const wlList = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    document.querySelectorAll('.cpy-cart-line__wishlist-btn').forEach(btn => {
      const saved = wlList.includes(btn.dataset.handle);
      btn.classList.toggle('saved', saved);
      btn.innerHTML = (saved ? '♥ GUARDADO' : '♡ GUARDAR');
      btn.addEventListener('click', () => CPY.saveCartItemToWishlist(btn.dataset.handle, Number(btn.dataset.variant), btn));
    });
  },

  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  updateCartCount(count) {
    if (count === undefined) {
      this.getCart().then(cart => this.updateCartCount(cart.item_count));
      return;
    }
    document.querySelectorAll('.cpy-cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('visible', count > 0);
    });
  },

  formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  },

  openCartDrawer() {
    this._cartTrigger = document.activeElement;
    if (!this.cartDrawer) return;
    this.cartDrawer.classList.add('open');
    this.cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = this.cartDrawer.querySelector('button[data-close-drawer]');
    if (closeBtn) closeBtn.focus();
    this.refreshCartDrawer();
  },

  closeCartDrawer() {
    if (!this.cartDrawer) return;
    this.cartDrawer.classList.remove('open');
    this.cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this._cartTrigger) { this._cartTrigger.focus(); this._cartTrigger = null; }
  },

  openQuickAddModal(_productHandle, variantData, optionNamesData) {
    this._modalTrigger = document.activeElement;
    if (!this.quickAddModal) return;
    const content = document.getElementById('quick-add-modal-content');
    if (!content) return;
    const variants = JSON.parse(variantData || '[]');
    if (variants.length === 1 && variants[0].available) {
      this.addToCart(variants[0].id, 1);
      return;
    }
    this._qamVariants = variants;
    const optCount = variants[0]?.options?.length || 1;
    const rawNames = optionNamesData ? JSON.parse(optionNamesData) : [];
    const OPT_NAMES = rawNames.length ? rawNames.map(n => n.toUpperCase()) : ['TALLA', 'TIPO', 'OPCIÓN 3'];

    let optionsHtml = '';
    if (optCount === 1) {
      optionsHtml = `
        <div class="quick-add-modal__label">SELECCIONA TALLA</div>
        <div class="quick-add-modal__variants" data-qam-group="0">
          ${variants.map(v => `
            <button class="variant-btn ${!v.available ? 'sold-out' : ''}"
              data-value="${v.options[0]}"
              onclick="CPY.selectQuickOption(this, 0)">${v.options[0]}</button>
          `).join('')}
        </div>`;
    } else {
      optionsHtml = variants[0].options.map((_, i) => {
        const uniqueVals = [...new Set(variants.map(v => v.options[i]))];
        return `
          <div class="quick-add-modal__label">${OPT_NAMES[i] || 'OPCIÓN'}</div>
          <div class="quick-add-modal__variants" data-qam-group="${i}">
            ${uniqueVals.map(val => {
              const hasAvail = variants.some(v => v.options[i] === val && v.available);
              return `<button class="variant-btn ${!hasAvail ? 'sold-out' : ''}"
                data-value="${val}"
                onclick="CPY.selectQuickOption(this, ${i})">${val}</button>`;
            }).join('')}
          </div>`;
      }).join('');
    }

    content.innerHTML = `
      <div class="quick-add-modal__title">${variants[0]?.product_title || ''}</div>
      <div class="quick-add-modal__price">${this.formatMoney(variants[0]?.price || 0)}</div>
      ${optionsHtml}
      <button class="quick-add-modal__add" data-selected-variant="" onclick="CPY.confirmQuickAdd()">
        AGREGAR AL CARRO
      </button>
    `;
    this.quickAddModal.classList.add('open');
    this.quickAddModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = this.quickAddModal.querySelector('button[data-close-modal]');
    if (closeBtn) closeBtn.focus();
  },

  selectQuickOption(btn, groupIndex) {
    const group = btn.closest('[data-qam-group]');
    group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const variants = this._qamVariants || [];
    const optCount = variants[0]?.options?.length || 1;
    // Collect all current selections
    const selections = {};
    document.querySelectorAll('[data-qam-group]').forEach(g => {
      const active = g.querySelector('.variant-btn.active');
      if (active) selections[parseInt(g.dataset.qamGroup)] = active.dataset.value;
    });
    // Update cross-option availability in other groups
    document.querySelectorAll('[data-qam-group]').forEach(g => {
      const gi = parseInt(g.dataset.qamGroup);
      if (gi === groupIndex) return;
      g.querySelectorAll('.variant-btn').forEach(b => {
        const testSel = { ...selections, [gi]: b.dataset.value };
        const avail = variants.some(v => v.options.every((opt, i) => testSel[i] === opt) && v.available);
        b.classList.toggle('sold-out', !avail);
        b.disabled = !avail;
      });
    });
    // Set variant if all options selected
    if (Object.keys(selections).length === optCount) {
      const match = variants.find(v => v.options.every((opt, i) => selections[i] === opt));
      const addBtn = document.querySelector('.quick-add-modal__add');
      if (addBtn) addBtn.dataset.selectedVariant = match?.id || '';
    }
  },

  async confirmQuickAdd() {
    const addBtn = document.querySelector('.quick-add-modal__add');
    const variantId = addBtn?.dataset.selectedVariant;
    if (!variantId) {
      const groups = document.querySelectorAll('[data-qam-group]');
      const missing = [];
      groups.forEach(g => { if (!g.querySelector('.variant-btn.active')) missing.push(g.dataset.qamGroup); });
      const labels = document.querySelectorAll('.quick-add-modal__label');
      const missingNames = missing.map(i => labels[parseInt(i)]?.textContent?.trim() || `OPCIÓN ${parseInt(i)+1}`);
      addBtn.textContent = missingNames.length ? `ELIGE: ${missingNames.join(' + ')}` : 'SELECCIONA UNA OPCIÓN';
      return;
    }
    addBtn.textContent = 'AGREGANDO...';
    await this.addToCart(variantId, 1);
    this.closeQuickAddModal();
  },

  closeQuickAddModal() {
    if (!this.quickAddModal) return;
    this.quickAddModal.classList.remove('open');
    this.quickAddModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this._modalTrigger) { this._modalTrigger.focus(); this._modalTrigger = null; }
  },

  updateSelectedVariant() {
    const activeButtons = {};
    document.querySelectorAll('[data-option-group]').forEach(group => {
      const active = group.querySelector('.variant-btn.active');
      if (active) activeButtons[group.dataset.optionGroup] = active.dataset.value;
    });
    const variants = window.CPY_VARIANTS || [];
    const match = variants.find(v => {
      return v.options.every((opt, i) => {
        return activeButtons[`option-${i + 1}`] === opt;
      });
    });
    // Update option labels (TALLA: S → TALLA: 2XL, TIPO: Regular → TIPO: Oversize)
    Object.entries(activeButtons).forEach(([key, value]) => {
      const pos = key.replace('option-', '');
      const labelEl = document.getElementById('selected-opt-' + pos);
      if (labelEl) labelEl.textContent = value;
    });

    if (match) {
      const input = document.querySelector('[name="id"]');
      if (input) input.value = match.id;
      const priceEl = document.querySelector('.cpy-product__price');
      if (priceEl) {
        if (match.compare_at_price > match.price) {
          priceEl.innerHTML = `<span class="sale-price">${this.formatMoney(match.price)}</span><span class="compare-price">${this.formatMoney(match.compare_at_price)}</span>`;
        } else {
          priceEl.innerHTML = this.formatMoney(match.price);
        }
      }
      const addBtn = document.querySelector('[data-add-btn]');
      if (addBtn) {
        if (!match.available) {
          addBtn.disabled = true; addBtn.textContent = 'AGOTADO';
        } else {
          addBtn.disabled = false; addBtn.textContent = 'AGREGAR AL CARRO';
        }
      }
      // Back-in-stock form toggle
      const bisForm = document.getElementById('back-in-stock-form');
      const bisBody = document.getElementById('bis-variant-body');
      if (bisForm) {
        bisForm.style.display = match.available ? 'none' : 'block';
        if (bisBody) {
          bisBody.value = `Producto: ${match.product_title || ''} | Variante: ${match.title} | ID: ${match.id}`;
        }
      }
    }
  },

  updateCrossOptionAvailability() {
    const variants = window.CPY_VARIANTS || [];
    const groups = document.querySelectorAll('[data-option-group]');
    if (!variants.length || groups.length < 2) return;
    groups.forEach((group, gIdx) => {
      // Collect selected values from all OTHER groups
      const others = {};
      groups.forEach((g, i) => {
        if (i === gIdx) return;
        const active = g.querySelector('.variant-btn.active');
        if (active) others[i] = active.dataset.value;
      });
      // For each button in this group, check if any variant with that value + other selections is available
      group.querySelectorAll('.variant-btn').forEach(btn => {
        const val = btn.dataset.value;
        const avail = variants.some(v => {
          if (v.options[gIdx] !== val) return false;
          for (const [i, sel] of Object.entries(others)) {
            if (v.options[parseInt(i)] !== sel) return false;
          }
          return v.available;
        });
        btn.classList.toggle('sold-out', !avail);
        if (!btn.classList.contains('active')) btn.disabled = !avail;
      });
    });
  },

  initScrollReveal() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(el => {
        if (el.isIntersecting) {
          el.target.classList.add('revealed');
          observer.unobserve(el.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
  },

  /* ── Card sliders (product grid) ───────────────────────── */
  _initCardSlider(slider) {
    if (slider.dataset.sliderInit) return;
    slider.dataset.sliderInit = '1';
    const slides = slider.querySelectorAll('.card-slider__slide');
    const dots   = slider.querySelectorAll('.card-slider__dot');
    const prev   = slider.querySelector('.card-slider__arrow--prev');
    const next   = slider.querySelector('.card-slider__arrow--next');
    if (slides.length <= 1) return;

    let current = 0;
    function goTo(index) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    }
    prev?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(current - 1); });
    next?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(current + 1); });
    dots.forEach((dot, i) => dot.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(i); }));
    let tx = 0;
    slider.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => {
      const diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  },

  initCardSliders() {
    document.querySelectorAll('[data-card-slider]').forEach(slider => CPY._initCardSlider(slider));
  },

  /* ── Product page slider ────────────────────────────────── */
  initProductSlider() {
    const el = document.querySelector('[data-product-slider]');
    if (!el) return;

    const slides  = el.querySelectorAll('.product-gallery-slider__slide');
    const dots    = el.querySelectorAll('.product-gallery-slider__dot');
    const thumbs  = el.querySelectorAll('.product-gallery-slider__thumb');
    const mainEl  = el.querySelector('.product-gallery-slider__main') || el;
    const prev    = el.querySelector('.product-gallery-slider__arrow--prev');
    const next    = el.querySelector('.product-gallery-slider__arrow--next');
    const counter = el.querySelector('[data-slider-current]');
    const isMobile = () => window.innerWidth <= 749;

    // Hint "▼ VER DESCRIPCIÓN" — solo en desktop, dentro del track
    const track = el.querySelector('.product-gallery-slider__track');
    if (track) {
      const hint = document.createElement('div');
      hint.className = 'product-gallery-slider__scroll-hint';
      hint.textContent = '▼  VER DESCRIPCIÓN';
      track.appendChild(hint);
    }

    // Función auxiliar: scroll + abre acordeón de descripción
    function scrollToDesc() {
      const desc = document.querySelector('.cpy-product__desc-toggle');
      if (!desc) return;
      desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const btn     = desc.querySelector('.cpy-product__desc-btn');
      const content = desc.querySelector('.cpy-product__desc-content');
      if (btn && content && !content.classList.contains('open')) {
        content.classList.add('open');
        const icon = btn.querySelector('.acc-icon');
        if (icon) icon.textContent = '−';
      }
    }

    // MOBILE: tap en imagen → ir a descripción
    // DESKTOP: clic no hace scroll (se usa el propio scroll del usuario)
    slides.forEach(slide => {
      slide.addEventListener('click', () => {
        if (isMobile()) scrollToDesc();
      });
    });

    if (slides.length <= 1) return; // una sola imagen: no hay navegación

    let current = 0;

    function goTo(index) {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      thumbs[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
      thumbs[current]?.classList.add('active');
      if (counter) counter.textContent = current + 1;
      // Scroll thumbnail a la vista (desktop)
      thumbs[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    prev?.addEventListener('click',  e => { e.stopPropagation(); goTo(current - 1); });
    next?.addEventListener('click',  e => { e.stopPropagation(); goTo(current + 1); });
    dots.forEach((d, i) => d.addEventListener('click', e => { e.stopPropagation(); goTo(i); }));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

    // DESKTOP: navegación con flechas del teclado
    document.addEventListener('keydown', e => {
      const focused = document.activeElement?.tagName;
      if (focused === 'INPUT' || focused === 'TEXTAREA' || focused === 'SELECT') return;
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    // MOBILE: swipe horizontal en el área principal
    let tx = 0, ty = 0;
    mainEl.addEventListener('touchstart', e => {
      tx = e.touches[0].clientX;
      ty = e.touches[0].clientY;
    }, { passive: true });
    mainEl.addEventListener('touchend', e => {
      const dx = tx - e.changedTouches[0].clientX;
      const dy = ty - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  },

  /* ── Sticky Add-to-Cart (mobile) ────────────────────────── */
  initStickyAtc() {
    const mainBtn   = document.getElementById('add-to-cart-btn');
    const stickyBar = document.getElementById('product-sticky-atc');
    const stickyBtn = document.getElementById('sticky-atc-btn');
    if (!mainBtn || !stickyBar) return;

    // Mostrar sticky cuando el botón principal sale del viewport
    const obs = new IntersectionObserver(entries => {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(mainBtn);

    // Clic en sticky → dispara el form principal
    stickyBtn?.addEventListener('click', () => {
      const form = document.getElementById('product-form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  },

  /* ── Countdown ────────────────────────────────────────────── */
  initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(el => {
      const target = new Date(el.dataset.countdown).getTime();
      if (!isFinite(target)) return;
      const blocksEl = el.querySelector('.cpy-countdown__blocks, .cpy-drop-hero__countdown-blocks');
      const linkEl = el.querySelector('.cpy-countdown__live-link');
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) {
          clearInterval(interval);
          if (el.dataset.reload) { window.location.reload(); return; }
          el.style.display = 'none';
          if (linkEl) linkEl.style.display = 'inline';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        const dEl = el.querySelector('[data-cd-days]');
        const hEl = el.querySelector('[data-cd-hours]');
        const mEl = el.querySelector('[data-cd-mins]');
        const sEl = el.querySelector('[data-cd-secs]');
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      };
      let interval;
      tick();
      interval = setInterval(tick, 1000);
    });
  },

  /* ── Drop tabs ────────────────────────────────────────────── */
  initDropTabs() {
    const tabs = document.querySelectorAll('.cpy-drop-tab');
    if (!tabs.length) return;
    const grid = document.getElementById('drop-product-grid');
    if (!grid) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const filter = tab.dataset.tab;
        grid.querySelectorAll('[data-product-type]').forEach(item => {
          if (filter === 'all' || item.dataset.productType === filter) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      });
    });
  },

  /* ── Wishlist ─────────────────────────────────────────────── */
  initWishlist() {
    CPY.updateWishlistUI();
    // Event delegation — catches buttons on all drops (current + future), regardless of render timing
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cpy-wishlist-btn');
      if (!btn || !btn.dataset.handle) return;
      e.stopPropagation();
      CPY.toggleWishlist(btn.dataset.handle);
    });
    const grid = document.getElementById('wishlist-grid');
    const emptyMsg = document.getElementById('wishlist-empty');
    const actionsBar = document.getElementById('wishlist-actions');
    const addAllBtn = document.getElementById('wishlist-add-all');
    const summaryEl = document.getElementById('wishlist-summary');
    if (!grid) return;
    const list = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    if (list.length === 0) {
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }

    /* helper: attach ATC click to a button (requires data-variant to be set) */
    function bindAtcBtn(btn) {
      btn.addEventListener('click', () => {
        const variantId = btn.dataset.variant;
        if (!variantId) return;
        const orig = btn.textContent;
        btn.textContent = '...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        }).then(() => {
          btn.textContent = 'AGREGADO ✓';
          CPY.refreshCartDrawer && CPY.refreshCartDrawer();
          const handle = btn.dataset.handle || btn.closest('[data-handle]')?.dataset.handle;
          setTimeout(() => {
            if (handle) {
              CPY.toggleWishlist(handle);
              const cardEl = btn.closest('.cpy-product-card');
              if (cardEl) { cardEl.remove(); CPY._updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg); }
            } else { btn.textContent = orig; btn.disabled = false; }
          }, 800);
        }).catch(() => { btn.textContent = 'ERROR'; btn.disabled = false; });
      });
    }

    Promise.all(list.map(handle =>
      fetch(`/products/${handle}.js`).then(r => r.ok ? r.json() : null)
    )).then(products => {
      const valid = products.filter(Boolean);

      valid.forEach(p => {
        const price = CPY.formatMoney(p.price);
        const card = document.createElement('div');
        const singleVariant = p.variants.length === 1;
        const available = p.variants.some(v => v.available);
        const lockUntil = window.CPY_DROP_LOCKS && window.CPY_DROP_LOCKS[p.handle];
        const isLocked = lockUntil ? (new Date(lockUntil) > new Date()) : false;

        let atcHtml;
        if (isLocked) {
          atcHtml = `<div class="cpy-wishlist-lock">
            <span class="cpy-wishlist-lock__label">DISPONIBLE EN</span>
            <span class="cpy-wishlist-lock__countdown" data-lock-until="${lockUntil}">--:--:--</span>
            <button class="cpy-wishlist-atc-btn" disabled>PRÓXIMAMENTE</button>
          </div>`;
        } else if (available) {
          if (singleVariant) {
            atcHtml = `<button class="cpy-wishlist-atc-btn"
              data-variant="${p.variants[0].id}"
              data-handle="${p.handle}"
              data-single="true">
              AGREGAR AL CARRITO
            </button>`;
          } else {
            const availableVariants = p.variants.filter(v => v.available);
            const hasMultipleOptions = p.variants[0]?.options?.length > 1;
            const chips = availableVariants.map(v => {
              const label = hasMultipleOptions ? v.title.replace(' / ', ' · ') : v.option1;
              return `<button class="cpy-wishlist-size-chip" data-variant="${v.id}" type="button">${label}</button>`;
            }).join('');
            atcHtml = `<div class="cpy-wishlist-sizes" data-handle="${p.handle}">
              <div class="cpy-wishlist-size-chips">${chips}</div>
              <button class="cpy-wishlist-atc-btn" data-handle="${p.handle}" data-single="false" data-variant="" disabled>
                AGREGAR AL CARRITO
              </button>
            </div>`;
          }
        } else {
          atcHtml = `<span class="cpy-wishlist-sold">AGOTADO</span>`;
        }

        card.className = 'cpy-product-card';
        card.innerHTML = `
          <a href="/products/${p.handle}" class="cpy-product-card__img-link">
            <div class="cpy-product-card__img">
              <div class="card-slider__track">
                <div class="card-slider__slide active">
                  <img src="${p.featured_image}" alt="${p.title}" loading="lazy" width="600" height="750">
                </div>
              </div>
            </div>
          </a>
          <button class="cpy-wishlist-btn saved" data-handle="${p.handle}" aria-label="Quitar de guardados">
            <span class="cpy-wishlist-btn__icon">♥</span>
          </button>
          <div class="cpy-product-card__info">
            <a href="/products/${p.handle}">
              <div class="cpy-product-card__title">${p.title}</div>
            </a>
            <div class="cpy-product-card__price-row">
              <span class="price price--regular">${price}</span>
            </div>
            ${atcHtml}
          </div>`;

        card.querySelector('.cpy-wishlist-btn').addEventListener('click', () => {
          CPY.toggleWishlist(p.handle);
          card.remove();
          CPY._updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg);
        });

        const countdownEl = card.querySelector('.cpy-wishlist-lock__countdown');
        if (countdownEl) {
          const target = new Date(countdownEl.dataset.lockUntil).getTime();
          const tickLock = () => {
            const diff = target - Date.now();
            if (diff <= 0) { window.location.reload(); return; }
            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff % 86400000) / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            countdownEl.textContent = d > 0
              ? `${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
              : `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
          };
          tickLock(); setInterval(tickLock, 1000);
        }

        // Bind ATC button(s) — single-variant enabled, multi-variant enabled after chip pick
        card.querySelectorAll('.cpy-wishlist-atc-btn').forEach(btn => bindAtcBtn(btn));

        // Bind size chip clicks for multi-variant products
        card.querySelectorAll('.cpy-wishlist-size-chip').forEach(chip => {
          chip.addEventListener('click', () => {
            const sizesEl = chip.closest('.cpy-wishlist-sizes');
            sizesEl.querySelectorAll('.cpy-wishlist-size-chip').forEach(c => c.classList.remove('active'));
            chip.classList.add('active');
            const atcBtn = sizesEl.querySelector('.cpy-wishlist-atc-btn');
            atcBtn.dataset.variant = chip.dataset.variant;
            atcBtn.disabled = false;
            CPY._updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg);
          });
        });

        // Append card first so _updateWishlistBar sees correct children count
        grid.appendChild(card);

        // Pre-select chip if variant was saved from cart (must happen after appendChild)
        const savedVariants = JSON.parse(localStorage.getItem('cpy_wishlist_variants') || '{}');
        const savedVid = savedVariants[p.handle];
        if (savedVid) {
          const chip = card.querySelector(`.cpy-wishlist-size-chip[data-variant="${savedVid}"]`);
          if (chip) chip.click();
        }
      });

      /* ── Barra "Agregar todo" ── */
      CPY._updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg);

      if (addAllBtn) {
        addAllBtn.addEventListener('click', () => {
          const btns = [...grid.querySelectorAll('.cpy-wishlist-atc-btn:not([disabled])')].filter(b => b.dataset.variant);
          if (!btns.length) return;
          addAllBtn.disabled = true;
          addAllBtn.textContent = 'AGREGANDO...';
          const items = btns.map(b => ({ id: Number(b.dataset.variant), quantity: 1 }));
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          }).then(() => {
            addAllBtn.textContent = `${items.length} AGREGADOS ✓`;
            CPY.refreshCartDrawer && CPY.refreshCartDrawer();
            setTimeout(() => {
              btns.forEach(b => {
                const handle = b.dataset.handle || b.closest('[data-handle]')?.dataset.handle;
                if (handle) CPY.toggleWishlist(handle);
                const cardEl = b.closest('.cpy-product-card');
                if (cardEl) cardEl.remove();
              });
              CPY._updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg);
              addAllBtn.textContent = 'AGREGAR TODO AL CARRITO';
              addAllBtn.disabled = false;
            }, 1000);
          }).catch(() => {
            addAllBtn.textContent = 'ERROR — INTENTA DE NUEVO';
            addAllBtn.disabled = false;
          });
        });
      }
    });
  },

  _updateWishlistBar(grid, actionsBar, summaryEl, addAllBtn, emptyMsg) {
    const total = grid.children.length;
    if (!total) {
      if (actionsBar) actionsBar.style.display = 'none';
      if (emptyMsg) emptyMsg.style.display = 'block';
      return;
    }
    const addable = [...grid.querySelectorAll('.cpy-wishlist-atc-btn:not([disabled])')].filter(b => b.dataset.variant).length;
    const locked  = grid.querySelectorAll('.cpy-wishlist-lock').length;
    const multiPending = [...grid.querySelectorAll('.cpy-wishlist-atc-btn[data-single="false"]')].filter(b => !b.dataset.variant).length;

    if (actionsBar) actionsBar.style.display = 'flex';
    if (emptyMsg) emptyMsg.style.display = 'none';
    if (summaryEl) {
      let parts = [`${total} PRODUCTO${total !== 1 ? 'S' : ''}`];
      if (locked) parts.push(`${locked} CON TEMPORIZADOR`);
      if (multiPending) parts.push(`${multiPending} ELIGE TALLA`);
      summaryEl.textContent = parts.join(' · ');
    }
    if (addAllBtn) {
      addAllBtn.style.display = addable > 0 ? '' : 'none';
    }
  },

  toggleWishlist(handle) {
    const list = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    localStorage.setItem('cpy_wishlist', JSON.stringify(list));
    CPY.updateWishlistUI();
  },

  updateWishlistUI() {
    const list = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    document.querySelectorAll('.cpy-wishlist-btn').forEach(btn => {
      const saved = list.includes(btn.dataset.handle);
      btn.classList.toggle('saved', saved);
      btn.querySelector('.cpy-wishlist-btn__icon').textContent = saved ? '♥' : '♡';
    });
    const icon = document.querySelector('.cpy-wishlist-icon');
    if (icon) icon.textContent = list.length ? '♥' : '♡';
    const count = document.querySelector('.cpy-wishlist-count');
    if (count) {
      count.textContent = list.length;
      count.style.display = list.length ? 'flex' : 'none';
    }
  },

  /* ── Product card lock overlay ────────────────────────────── */
  /* ── Ultra Collection ─────────────────────────────────── */
  initUltraCollection() {
    if (!document.querySelector('[data-ultra]')) return;

    // Scroll reveal with staggered delay
    const revealEls = document.querySelectorAll('[data-ultra-reveal]');
    if (revealEls.length) {
      const revealObs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = parseInt(el.dataset.ultraDelay || '0', 10);
          setTimeout(() => el.classList.add('is-visible'), delay);
          revealObs.unobserve(el);
        });
      }, { threshold: 0.12 });
      revealEls.forEach(el => revealObs.observe(el));
    }

    // Parallax on product images
    const parallaxSections = document.querySelectorAll('[data-ultra-parallax]');
    if (parallaxSections.length && window.matchMedia('(min-width: 850px)').matches) {
      // Cache img references once to avoid per-scroll DOM queries
      const parallaxItems = Array.from(parallaxSections).map(wrap => ({
        wrap,
        img: wrap.querySelector('img')
      }));

      let rafPending = false;
      const onScroll = () => {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(() => {
          rafPending = false;
          // Batch ALL reads first (getBoundingClientRect, window.innerHeight)
          const vh = window.innerHeight;
          const rects = parallaxItems.map(({ wrap }) => wrap.getBoundingClientRect());
          // Then do ALL writes
          parallaxItems.forEach(({ img }, i) => {
            if (!img) return;
            const rect = rects[i];
            if (rect.bottom < 0 || rect.top > vh) return;
            const progress = (vh - rect.top) / (vh + rect.height);
            const shift = (progress - 0.5) * 80;
            img.style.transform = `translateY(${shift}px)`;
          });
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Size chip selection
    document.querySelectorAll('.ultra-product__size-chips').forEach(group => {
      group.querySelectorAll('.ultra-size-chip').forEach(chip => {
        chip.addEventListener('click', () => {
          group.querySelectorAll('.ultra-size-chip').forEach(c => c.classList.remove('active'));
          chip.classList.add('active');
          // Hide size warning
          const section = chip.closest('.ultra-product');
          if (section) section.querySelector('.ultra-size-warning')?.style?.setProperty('display','none');
        });
      });
    });

    // Wishlist state init
    const wlList = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
    document.querySelectorAll('[data-ultra-wishlist]').forEach(btn => {
      const handle = btn.dataset.handle;
      if (wlList.includes(handle)) {
        btn.classList.add('saved');
        btn.querySelector('.ultra-wishlist-btn__icon').textContent = '♥';
        btn.querySelector('.ultra-wishlist-btn__text').textContent = 'GUARDADO';
      }
      btn.addEventListener('click', () => {
        const list = JSON.parse(localStorage.getItem('cpy_wishlist') || '[]');
        const idx = list.indexOf(handle);
        const adding = idx === -1;
        if (adding) list.push(handle);
        else list.splice(idx, 1);
        localStorage.setItem('cpy_wishlist', JSON.stringify(list));
        btn.classList.toggle('saved', adding);
        btn.querySelector('.ultra-wishlist-btn__icon').textContent = adding ? '♥' : '♡';
        btn.querySelector('.ultra-wishlist-btn__text').textContent = adding ? 'GUARDADO' : 'GUARDAR';
        CPY.updateWishlistUI();
      });
    });

    // ATC buttons
    document.querySelectorAll('[data-ultra-atc]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const section = btn.closest('.ultra-product');

        // Get variant
        let variantId = null;
        const activeChip = section?.querySelector('.ultra-size-chip.active');
        if (activeChip) {
          variantId = activeChip.dataset.variant;
        } else {
          const hidden = section?.querySelector('.ultra-variant-hidden');
          if (hidden) variantId = hidden.value;
        }

        // Size required?
        const hasChips = section?.querySelectorAll('.ultra-size-chip:not(.ultra-size-chip--oos)').length > 0;
        if (hasChips && !activeChip) {
          const warn = section?.querySelector('.ultra-size-warning');
          if (warn) { warn.style.display = 'block'; }
          // Shake chips
          const chips = section?.querySelector('.ultra-product__size-chips');
          chips?.classList.add('shake');
          setTimeout(() => chips?.classList.remove('shake'), 500);
          return;
        }

        if (!variantId) return;

        btn.classList.add('loading');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          btn.classList.remove('loading');
          btn.classList.add('done');
          const originalText = btn.querySelector('.ultra-atc-btn__text').textContent;
          btn.querySelector('.ultra-atc-btn__text').textContent = '✓ AGREGADO';
          CPY.updateCartCount();
          setTimeout(() => {
            btn.classList.remove('done');
            btn.querySelector('.ultra-atc-btn__text').textContent = originalText;
          }, 2200);
        } catch {
          btn.classList.remove('loading');
          btn.querySelector('.ultra-atc-btn__text').textContent = 'ERROR — INTENTA DE NUEVO';
          setTimeout(() => {
            btn.querySelector('.ultra-atc-btn__text').textContent = 'AGREGAR AL CARRITO';
          }, 2000);
        }
      });
    });
  },

  /* ── Product Recommendations ─────────────────────────────── */
  initRecommendations() {
    const section = document.querySelector('[data-recommendations-section]');
    if (!section) return;
    const productId = section.dataset.productId;
    const sectionId = section.dataset.sectionId;
    const limit     = section.dataset.limit || 4;
    if (!productId || !sectionId) return;

    const url = `/recommendations/products?product_id=${productId}&limit=${limit}&section_id=${sectionId}`;
    fetch(url)
      .then(r => r.ok ? r.text() : null)
      .then(html => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.cpy-recommendations__inner');
        if (!inner) return;
        section.innerHTML = '';
        section.appendChild(inner);
        // Init card sliders for newly injected cards
        section.querySelectorAll('[data-card-slider]').forEach(el => CPY._initCardSlider(el));
        CPY.updateWishlistUI();
        CPY.initCardLocks();
      })
      .catch(() => {});
  },

  initCardLocks() {
    if (!window.CPY_DROP_LOCKS) return;
    document.querySelectorAll('.cpy-product-card').forEach(card => {
      const wishlistBtn = card.querySelector('.cpy-wishlist-btn');
      if (!wishlistBtn) return;
      const handle = wishlistBtn.dataset.handle;
      const lockUntil = window.CPY_DROP_LOCKS[handle];
      if (!lockUntil || new Date(lockUntil) <= new Date()) return;

      const overlay = card.querySelector('.cpy-product-card__overlay');
      if (!overlay) return;

      overlay.innerHTML = `<div class="cpy-card-lock">
        <span class="cpy-card-lock__countdown" data-lock-until="${lockUntil}">--:--:--</span>
        <button class="cpy-product-card__quick-add cpy-product-card__quick-add--locked" disabled onclick="event.preventDefault()">PRÓXIMAMENTE</button>
      </div>`;

      const countdownEl = overlay.querySelector('.cpy-card-lock__countdown');
      const target = new Date(lockUntil).getTime();
      const tick = () => {
        const diff = target - Date.now();
        if (diff <= 0) { window.location.reload(); return; }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        countdownEl.textContent = d > 0
          ? `${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
          : `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      };
      tick();
      setInterval(tick, 1000);
    });
  },

  /* ── Packaging Selector ──────────────────────────────────── */
  initPackagingSelector() {
    CPY._pkgSelected = '1'; // default: free tier

    // Intercept ALL checkout buttons via delegation (before they navigate)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#cart-drawer-checkout, .cpy-checkout-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      CPY._openPackagingDrawer();
    }, true); // capture phase — fires before any bubble-phase listeners

    // Select packaging option card
    document.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-pkg-option]');
      if (!opt) return;
      CPY._selectPkg(opt.dataset.pkgOption);
    });

    // Close button
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-pkg-close]')) return;
      CPY._closePackagingDrawer();
    });

    // Backdrop close
    document.addEventListener('click', (e) => {
      if (!e.target.matches('[data-packaging-backdrop]')) return;
      CPY._closePackagingDrawer();
    });

    // Skip → go to checkout without adding packaging (free tier stays, no line item)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-pkg-skip]')) return;
      CPY._closePackagingDrawer();
      CPY._goToCheckout();
    });

    // Confirm → process packaging then go to checkout
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-pkg-confirm]')) return;
      CPY._confirmPackaging();
    });
  },

  _openPackagingDrawer() {
    const drawer = document.querySelector('[data-packaging-drawer]');
    if (!drawer) { CPY._goToCheckout(); return; }
    // Reset to free tier every time drawer opens
    CPY._selectPkg('1');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
  },

  _closePackagingDrawer() {
    const drawer = document.querySelector('[data-packaging-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  },

  _selectPkg(tier) {
    CPY._pkgSelected = tier;
    document.querySelectorAll('[data-pkg-option]').forEach(opt => {
      const selected = opt.dataset.pkgOption === tier;
      opt.classList.toggle('cpy-pkg-option--selected', selected);
      // Toggle free badge color
      const badge = opt.querySelector('[data-free-badge]');
      if (badge) {
        badge.className = selected
          ? 'cpy-pkg-option__badge cpy-pkg-option__badge--free-selected'
          : 'cpy-pkg-option__badge cpy-pkg-option__badge--free';
      }
    });
  },

  async _confirmPackaging() {
    const confirmBtn = document.querySelector('[data-pkg-confirm]');
    if (confirmBtn) { confirmBtn.textContent = 'Procesando...'; confirmBtn.disabled = true; }

    try {
      // 1. Remove any previously added packaging from cart
      await CPY._removeAllPackagingFromCart();

      // 2. Add selected paid tier (if not free)
      const selectedOpt = document.querySelector(`[data-pkg-option="${CPY._pkgSelected}"]`);
      const variantId = selectedOpt?.dataset.pkgVariant;
      if (variantId && variantId.trim() !== '') {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _packaging: 'true' } }]
          })
        });
        if (!res.ok) throw new Error('Cart add failed');
      }
    } catch (err) {
      console.error('[CPY] Packaging error:', err);
    }

    CPY._closePackagingDrawer();
    CPY._goToCheckout();
  },

  async _removeAllPackagingFromCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const updates = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties._packaging) {
        updates[item.key] = 0;
      }
    });
    if (Object.keys(updates).length === 0) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  },

  _goToCheckout() {
    const code = localStorage.getItem('cpy_discount');
    window.location.href = code
      ? `/checkout?discount=${encodeURIComponent(code)}`
      : '/checkout';
  },
};

// ── Size Guide Modal — ARIA + Focus Trap ─────────────────────────────────────
(function() {
  var modal = document.getElementById('cpy-size-guide-modal');
  if (!modal) return;

  function getFocusable() {
    return Array.from(modal.querySelectorAll(
      'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    ));
  }
  function openModal() {
    modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = getFocusable(); if (f.length) f[0].focus();
  }
  function closeModal() {
    modal.setAttribute('aria-hidden','true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    var trigger = document.querySelector('[data-open-size-guide]');
    if (trigger) trigger.focus();
  }
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-open-size-guide]')) { e.preventDefault(); openModal(); }
    if (e.target.closest('[data-close-size-guide]')) { e.preventDefault(); closeModal(); }
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var focusable = getFocusable(); if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last.focus(); } }
    else { if (document.activeElement === last) { e.preventDefault(); first.focus(); } }
  });
})();

// ── Size Selector Validation — Shake + Error ──────────────────────────────────
(function() {
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    var selector = form.querySelector('[data-required-selector]');
    if (!selector) return;
    var selected = selector.querySelector('button.active, input:checked, select');
    var hasValue = selected
      ? (selected.tagName === 'SELECT' ? selected.value !== '' : true)
      : false;
    if (!hasValue) {
      e.preventDefault();
      selector.classList.remove('cpy-shake');
      void selector.offsetWidth; // reflow to restart animation
      selector.classList.add('cpy-shake');
      selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function() { selector.classList.remove('cpy-shake'); }, 600);
      var errMsg = form.querySelector('#cpy-size-error');
      if (errMsg) { errMsg.style.display = 'block'; setTimeout(function() { errMsg.style.display = 'none'; }, 3000); }
    }
  });
})();

// ── Localization Selector (currency/country) — handles multiple instances ─────
(function() {
  document.querySelectorAll('.cpy-localization__btn').forEach(function(btn) {
    var dropdownId = btn.getAttribute('aria-controls');
    var dropdown = dropdownId ? document.getElementById(dropdownId) : null;
    if (!dropdown) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      // Close all other open dropdowns first
      document.querySelectorAll('.cpy-localization__btn[aria-expanded="true"]').forEach(function(b) {
        if (b !== btn) {
          b.setAttribute('aria-expanded','false');
          var did = b.getAttribute('aria-controls');
          if (did) { var d = document.getElementById(did); if (d) d.hidden = true; }
        }
      });
      btn.setAttribute('aria-expanded', String(!isOpen));
      dropdown.hidden = isOpen;
    });
  });
  document.querySelectorAll('.cpy-localization__option').forEach(function(opt) {
    opt.addEventListener('click', function() {
      var formId = opt.getAttribute('data-form') || 'cpy-country-form';
      var form = document.getElementById(formId);
      if (!form) return;
      form.querySelector('[name="country_code"]').value = opt.getAttribute('data-country-code');
      form.submit();
    });
  });
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.cpy-localization')) {
      document.querySelectorAll('.cpy-localization__btn[aria-expanded="true"]').forEach(function(btn) {
        btn.setAttribute('aria-expanded','false');
        var did = btn.getAttribute('aria-controls');
        if (did) { var d = document.getElementById(did); if (d) d.hidden = true; }
      });
    }
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  CPY.init();
  CPY.initCardSliders();
  CPY.initProductSlider();
  CPY.initStickyAtc();
  CPY.initCountdown();
  CPY.initDropTabs();
  CPY.initWishlist();
  CPY.initCardLocks();
  CPY.initUltraCollection();
  CPY.initRecommendations();
  CPY.initPackagingSelector();
});


// Cookie Consent
(function() {
  var CONSENT_KEY = 'cpy_cookie_consent';
  var banner = document.getElementById('cpy-cookie-banner');
  if (!banner) return;
  if (!localStorage.getItem(CONSENT_KEY)) {
    banner.style.display = 'block';
  }
  // Queries inside null-guard via banner reference to avoid TypeError if buttons are absent
  banner.querySelector('#cpy-cookie-accept').addEventListener('click', function() {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ consent: 'all', date: new Date().toISOString() }));
    banner.style.display = 'none';
    document.dispatchEvent(new Event('cpy:consent:granted'));
  });
  banner.querySelector('#cpy-cookie-essential').addEventListener('click', function() {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ consent: 'essential', date: new Date().toISOString() }));
    banner.style.display = 'none';
  });
})();
